import { createSelectFilterChip } from 'components/filters/createSelectFilterChip';
import { invoiceTypeOptions } from './common/options';

export const InvoiceTypeFilterChip = createSelectFilterChip(invoiceTypeOptions, { name: 'type' });
